<script>
import { isBefore, isWithinInterval, parseISO, addMonths } from 'date-fns';
import { mapGetters } from 'vuex';

export default {
  name: 'CardsListItemAliment',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      contrats: 'contrats/contrats'
    }),
    numContrat () {
      return this.contrats
        .filter(c => c.numArticle === this.item.numArticle)
        .filter(c => isWithinInterval(Date.now(), { start: parseISO(c.dateDebut), end: parseISO(c.dateFin) }))
        .map(c => c.numContrat)
        .shift();
    },
    alerteContrat () {
      const contratsAlerte = this.contrats
        .filter(c => c.numArticle === this.item.numArticle)
        .filter(c => isBefore(parseISO(c.dateFin), addMonths(Date.now(), 1)) && c.qteRestante > 0);

      return contratsAlerte.length > 0;
    }
  }
};
</script>
<template>
  <div class="list-item">
    <div class="list-item-content">
      <div>
        <strong>{{ item.libelle }}</strong><sub class="num-article">{{ item.numArticle }}</sub>
        <div v-if="numContrat">
          <span class="secondary--text">Contrat : {{ numContrat }}</span>
          <v-tooltip
            v-if="alerteContrat"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                color="warning"
                class="ml-1"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>Le contrat est non soldé et expire dans moins d'un mois.</span>
          </v-tooltip>
        </div>
      </div>
      <div class="actions-container">
        <slot
          name="actions"
          :item="item"
        />
      </div>
    </div>
    <div v-if="item.supplementations && item.supplementations.length">
      <v-menu
        bottom
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="secondary--text supp"
            v-bind="attrs"
            v-on="on"
          >
            Supplémentations disponibles
            <v-icon
              v-if="attrs['aria-expanded'] === 'false'"
              color="secondary"
              size="30"
            >
              mdi-menu-down
            </v-icon>
            <v-icon
              v-else
              color="secondary"
              size="30"
            >
              mdi-menu-up
            </v-icon>
          </div>
        </template>
        <v-list dense>
          <v-list-item
            v-for="supp in item.supplementations"
            :key="supp.numArticle"
          >
            <v-list-item-title>{{ supp.libelleLong }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-item {
  padding: 0.5em 1em;
}
.list-item-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  & > *:first-child {
    flex-grow: 1;
  }
  & > *:not(:first-child) {
    margin-left: 1em;
  }
}

.supp{
  cursor: pointer;
  display: inline-block;
  &:hover{
    background-color: rgba(0,0,0,0.1);
    }
}
</style>
